import marketplaceApi from "@/helpers/marketplaceApi";

const amplitudeMarketplace = (eventOptions) => {
    return marketplaceApi.post('/api/amplitude/', eventOptions);
}

export { amplitudeMarketplace };